import { useState, useEffect } from 'react';
import { Input } from '../Input';
import { SearchableDropdown } from '../SearchableDropdown';
import { IMenuItem } from '../Select';

type formValues = {
    clientName: string;
    clientBillingStreet: string;
    clientBillingCity: string;
    clientCountryId: string;
    clientMobilePhoneNumber: string;
    clientWorkPhoneNumber: string;
    clientRegistrationNumber: string;
    clientTaxNumber: string;
};

const initialFormValues: formValues = {
    clientName: '',
    clientBillingStreet: '',
    clientBillingCity: '',
    clientCountryId: '',
    clientMobilePhoneNumber: '',
    clientWorkPhoneNumber: '',
    clientRegistrationNumber: '',
    clientTaxNumber: '',
};

export default function EditInvoiceClientInfoModal({ context, clientInfo, onValuesChange, countries }: any) {
    const [form, setForm] = useState<formValues>(initialFormValues);

    useEffect(() => {
        setForm({
            clientName: context.values.clientName || clientInfo?.name || '',
            clientBillingStreet: context.values.clientBillingStreet || clientInfo?.billingAddress?.streetline1 || '',
            clientBillingCity: context.values.clientBillingCity || clientInfo?.billingAddress?.city || '',
            clientCountryId: context.values.clientCountryId || clientInfo?.billingAddress?.countryId || '',
            clientMobilePhoneNumber: context.values.clientMobilePhoneNumber || clientInfo?.mobilePhoneNumber || '',
            clientWorkPhoneNumber: context.values.clientWorkPhoneNumber || clientInfo?.workPhoneNumber || '',
            clientRegistrationNumber: context.values.clientRegistrationNumber || clientInfo?.registrationNumber || '',
            clientTaxNumber: context.values.clientTaxNumber || clientInfo?.taxNumber || '',
        });
    }, [clientInfo, context.values]);

    const updateField = (key: string, value: string | number) => {
        const updated = { ...form, [key]: value };
        setForm(updated);
        onValuesChange(updated);
    };
    const selectedCountry = countries.find((c: IMenuItem) => String(c.value) === String(form.clientCountryId));

    return (
        <div className="edit-client-info-modal">
            <Input isRequired id="clientName" label="Client Name" value={form.clientName} onChange={e => updateField('clientName', e.target.value)} />

            <Input
                isRequired
                id="clientBillingStreet"
                label="Billing Address"
                value={form.clientBillingStreet}
                onChange={e => updateField('clientBillingStreet', e.target.value)}
            />

            <Input
                isRequired
                id="clientBillingCity"
                label="City"
                value={form.clientBillingCity}
                onChange={e => updateField('clientBillingCity', e.target.value)}
            />
            <SearchableDropdown
                key={form.clientCountryId}
                label="Country"
                id="clientCountryId"
                menuItems={countries}
                selected={selectedCountry || { value: '', label: '' }}
                isRequired
                onChange={item => updateField('clientCountryId', item.value)}
            />

            <Input
                isRequired
                id="mobilePhoneNumber"
                label="Mobile Phone Number"
                value={form.clientMobilePhoneNumber}
                onChange={e => updateField('clientMobilePhoneNumber', e.target.value)}
            />

            <Input
                isRequired
                id="workPhoneNumber"
                label="Work Phone Number"
                value={form.clientWorkPhoneNumber}
                onChange={e => updateField('clientWorkPhoneNumber', e.target.value)}
            />

            <Input
                isRequired
                id="registrationNumber"
                label={clientInfo?.registrationNumberLabel}
                value={form.clientRegistrationNumber}
                onChange={e => updateField('clientRegistrationNumber', e.target.value)}
            />

            <Input
                isRequired
                id="taxNumber"
                label={clientInfo?.taxNumberLabel}
                value={form.clientTaxNumber}
                onChange={e => updateField('clientTaxNumber', e.target.value)}
            />
        </div>
    );
}
